module.exports = __webpack_public_path__ + "img/C35C04_F9C30C_EE9F04_E08304-256px.7303a8a6.png";